import { AnyAction, Dispatch } from 'redux';
import { intl } from '../../providers/IntlProvider';
import { getWorkpacks, getWorkpack, deleteWorkpack, addAttachmentWorkpack, putWorkpack } from '../../services/api';
import { ToastCategories, ToastTypes, ToastsActionTypes } from '../toasts';
import { getPublicWorkpack } from '../../services/external';
import { Workpack, WorkpacksActionTypes } from '.';

interface GetAllWorkpacksPayload {
  aircraft_id: string;
  page: number;
  limit: number;
  source?: string;
  status?: string;
  sort_by?: { [key: string]: 'asc' | 'desc' };
  search?: string;
}

export const getAllWorkpacks =
  ({ payload }: { payload: GetAllWorkpacksPayload }) =>
  async (dispatch: Dispatch): Promise<{ workpacks: Workpack[] } | null> => {
    const response = await getWorkpacks(payload);
    if (response?.workpacks) {
      dispatch({
        type: WorkpacksActionTypes.SAVE_ALL,
        payload: response?.workpacks,
      });
      return response;
    }
    return null;
  };

export const getSingleWorkpack =
  ({ payload }: { payload: { id: string } }) =>
  async (dispatch: Dispatch): Promise<Workpack | null> => {
    const response = await getWorkpack(payload.id);
    dispatch({
      type: WorkpacksActionTypes.SAVE,
      payload: response,
    });
    return response;
  };

export const updateWorkpack =
  ({ payload }: { payload: Workpack }) =>
  async (dispatch: Dispatch): Promise<Workpack | null> => {
    const response = await putWorkpack(payload);
    dispatch({
      type: WorkpacksActionTypes.UPDATE,
      payload: response,
    });
    return response;
  };

export const updateReduxWorkpack =
  ({ payload }: { payload: Workpack }) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch({
      type: WorkpacksActionTypes.UPDATE,
      payload,
    });
  };

export const uploadAttachment =
  ({ files, id }: { files: File[]; id: string }) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await addAttachmentWorkpack({ attachments: files, id });
    dispatch({
      type: WorkpacksActionTypes.SAVE,
      payload: response,
    });
  };

export const removeWorkpack =
  ({ payload }: { payload: { id: string } }) =>
  async (dispatch: Dispatch<AnyAction>): Promise<void> => {
    const response = await deleteWorkpack(payload.id);
    if (response && response.statusCode === 204) {
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.workpackDeleted' }),
          type: ToastTypes.SUCCESS,
          category: ToastCategories.FLASH,
          message: '',
        },
      });
      dispatch({
        type: WorkpacksActionTypes.DELETE,
        payload: response ? { removeId: payload } : {},
      });
    } else {
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.approveItemsError' }),
          type: ToastTypes.ERROR,
          category: ToastCategories.FLAG,
          message: '',
        },
      });
    }
  };

export const getPublicWorkpackDetails =
  ({ payload }: { payload: { id: string } }) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await getPublicWorkpack(payload);
    dispatch({
      type: WorkpacksActionTypes.SAVE_PUBLIC,
      payload: response,
    });
  };

export const setPublicWorkpackDetailsWithoutAPI =
  ({ payload }: { payload: Workpack }) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch({
      type: WorkpacksActionTypes.SAVE_PUBLIC,
      payload,
    });
  };
